// src/themes/index.js
export const themes = {
  locality: {
    primary: '#024B99',     // Blue (matches HeaderBar)
    secondary: '#BB4D9A',   // Purple       
    accent: '#06B6D4',      // Cyan
    success: '#10B981',     // Green
    bg: '#EDF2F8',              
    cardBg: '#FFFFFF',          
    text: {
      primary: '#1F2937',          
      secondary: '#6B7280',        
      inverse: '#FFFFFF'         
    },
    sidebar: {
      active: '#E3F2FD',    // Light blue
      activeText: '#024B99' // Dark blue
    }
  },
  groups: {
    primary: '#BB4D9A',     // Purple (matches HeaderBar)
    secondary: '#024B99',   // Blue
    accent: '#10B981',      // Green
    success: '#06B6D4',     // Cyan
    bg: '#FDFAFC',          // Mauve wash — ~3% #BB4D9A over white (was #EDF2F8, locality's neutral).
                            // Deliberate asymmetry: Groups context reads as a distinct place;
                            // Locality stays neutral. Cards use cardBg (unchanged white) so they
                            // lift off this wash — do not apply this value to card surfaces.
    cardBg: '#FFFFFF',
    text: {
      primary: '#1F2937',
      secondary: '#6B7280',
      inverse: '#FFFFFF'
    },
    sidebar: {
      active: '#F3E8FF',    // Light purple
      activeText: '#BB4D9A' // Dark purple
    }
  }
};
